import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function TeamsIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7.5C6 5.567 7.567 4 9.5 4C11.433 4 13 5.567 13 7.5C13 9.433 11.433 11 9.5 11C7.567 11 6 9.433 6 7.5ZM9.5 5.5C8.39543 5.5 7.5 6.39543 7.5 7.5C7.5 8.60457 8.39543 9.5 9.5 9.5C10.6046 9.5 11.5 8.60457 11.5 7.5C11.5 6.39543 10.6046 5.5 9.5 5.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 13.25C7.61466 13.25 6.32996 14.0388 5.49342 15.0686C4.68163 16.0681 4.31726 17.2591 4.15053 18.0791C3.92886 19.1692 4.8195 20 5.78168 20H13.2183C14.1805 20 15.0712 19.1692 14.8495 18.079C14.6828 17.2591 14.3184 16.068 13.5066 15.0686C12.6701 14.0388 11.3853 13.25 9.5 13.25ZM5.62045 18.378C5.76428 17.6706 6.06232 16.7474 6.65773 16.0144C7.22838 15.3118 8.09566 14.75 9.5 14.75C10.9044 14.75 11.7716 15.3118 12.3423 16.0144C12.9377 16.7474 13.2357 17.6706 13.3795 18.3779C13.3839 18.3992 13.3816 18.4105 13.38 18.4161C13.378 18.423 13.3735 18.4331 13.3627 18.4451C13.3404 18.4699 13.2924 18.5 13.2183 18.5H5.78168C5.7076 18.5 5.65961 18.4699 5.63727 18.4451C5.6265 18.4331 5.62198 18.423 5.62003 18.4161C5.61843 18.4105 5.61613 18.3992 5.62045 18.378Z"
        fill="currentColor"
      />
      <path
        d="M15.75 13.25C15.3358 13.25 15 13.5858 15 14C15 14.4142 15.3358 14.75 15.75 14.75C16.4816 14.75 17.0082 15.1097 17.4249 15.7C17.8573 16.3125 18.1288 17.1249 18.2917 17.8585C18.3292 18.0272 18.2835 18.1727 18.181 18.2877C18.073 18.409 17.895 18.5 17.6769 18.5H16.75C16.3358 18.5 16 18.8358 16 19.25C16 19.6642 16.3358 20 16.75 20H17.6769C18.9293 20 20.0631 18.9162 19.7561 17.5334C19.5753 16.719 19.2493 15.6834 18.6503 14.8349C18.0357 13.9642 17.0972 13.25 15.75 13.25Z"
        fill="currentColor"
      />
      <path
        d="M14.75 4C14.3358 4 14 4.33579 14 4.75C14 5.16421 14.3358 5.5 14.75 5.5C15.7632 5.5 16.5 6.29772 16.5 7.5C16.5 8.70228 15.7632 9.5 14.75 9.5C14.3358 9.5 14 9.83579 14 10.25C14 10.6642 14.3358 11 14.75 11C16.7744 11 18 9.33528 18 7.5C18 5.66472 16.7744 4 14.75 4Z"
        fill="currentColor"
      />
    </svg>
  );
};
